import T from 'i18n-react';

export default async () => {
  let mainStrings = await import('./pt/strings.json');

  T.setTexts(mainStrings.default);
};
